import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "new-comment" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("label", null, "Bericht toevoegen", -1)

import { ref } from 'vue'
import TextEditor from '@/components/service/TextEditor.vue'
import UploadQueue from '@/components/service/UploadQueue.vue'
import Uploader from '@/components/service/Uploader.vue'
import { NewServiceComment } from '@/types/service/newServiceComment'
import axios from 'axios'


export default /*#__PURE__*/_defineComponent({
  __name: 'NewComment',
  props: {
  modelType: String,
  modelId: String
},
  emits: ['commentCreated'],
  setup(__props, { emit }) {

const props = __props;





const newComment = ref<NewServiceComment>({
  body: null,
  shared_with_client: true,
  shared_with_solver: true,
  files: []
})

function newFileUploaded (file:{ name:string, url:string }) : void {
  newComment.value.files.push(file)
}

function fileDeleted (index:number) : void {
  newComment.value.files.splice(index, 1)
}

function createComment () : void {
  axios.post(process.env.VUE_APP_API_URL + '/' + props.modelType + '/' + props.modelId + '/comments', newComment.value).then(() => {
    emit('commentCreated')
    newComment.value = {
      body: null,
      shared_with_client: true,
      shared_with_solver: true,
      files: []
    }
  })
}

return (_ctx: any,_cache: any) => {
  const _component_a_col = _resolveComponent("a-col")!
  const _component_a_row = _resolveComponent("a-row")!
  const _component_a_button = _resolveComponent("a-button")!
  const _component_a_divider = _resolveComponent("a-divider")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_a_row, null, {
      default: _withCtx(() => [
        _createVNode(_component_a_col, { span: 24 }, {
          default: _withCtx(() => [
            _hoisted_2,
            _createVNode(TextEditor, {
              content: newComment.value.body,
              onContentChange: _cache[0] || (_cache[0] = ($event: any) => (newComment.value.body = $event))
            }, null, 8, ["content"])
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    (newComment.value.files.length)
      ? (_openBlock(), _createBlock(_component_a_row, { key: 0 }, {
          default: _withCtx(() => [
            _createVNode(_component_a_col, { span: 24 }, {
              default: _withCtx(() => [
                _createVNode(UploadQueue, {
                  "media-items": newComment.value.files,
                  onFileDeleted: fileDeleted
                }, null, 8, ["media-items"])
              ]),
              _: 1
            })
          ]),
          _: 1
        }))
      : _createCommentVNode("", true),
    _createVNode(_component_a_row, null, {
      default: _withCtx(() => [
        _createVNode(_component_a_col, { span: 24 }, {
          default: _withCtx(() => [
            _createVNode(_component_a_button, {
              type: "primary",
              style: {"margin":"0 8px 8px 0"},
              disabled: !newComment.value.body,
              onClick: createComment
            }, {
              default: _withCtx(() => [
                _createTextVNode("Bericht toevoegen")
              ]),
              _: 1
            }, 8, ["disabled"]),
            _createVNode(Uploader, {
              style: {"display":"inline-block"},
              base64: true,
              onNewFileUploaded: newFileUploaded,
              "upload-button": ""
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createVNode(_component_a_divider)
  ]))
}
}

})